import React, { Component } from 'react';
import icon1 from "../img/icon_1.png"
import icon2 from "../img/icon_2.png"
import icon3 from "../img/icon_3.png"
import DeveloperFAQ from './components/DeveloperFAQ';
import LAOSTimeline from './components/LaosTimeline';

const CONTENT = {
    main_title: "LAOS + Polkadot ↔︎ Bitcoin",
    main_text: `LAOS Network is extending Bridgeless Minting to Bitcoin with the BRC-721 standard 
    - a new mode to create, secure, and manage NFTs on Bitcoin at scale`,
    button_left: {
        text: "Read the paper",
        link: "https://eprint.iacr.org/2025/641"
    },
    button_right: {
        text: "Start Building",
        link: "https://builder.laosnetwork.io"
    },
    developer_tools: [
        {
            title: "How does LAOS work?",
            text: "Learn how LAOS connects without bridges to EVM chains and permits NFT minting at scale.",
            link: "https://docs.laosnetwork.io/learn/goals",
            icon: icon1,
            icon_right: false
        },
        {
            title: "Bridgeless Minting Explanation",
            text: "A deep dive on how Bridgeless Minting creates NFTs on any EVM, without paying the gas fees of that chain.",
            link: "https://docs.laosnetwork.io/learn/bridgeless-minting-intro",
            icon: icon2,
            icon_right: true
        },
        {
            title: "Quickstart Developer Scripts",
            text: "Use these simple script examples to mint assets with LAOS on any EVM-compatible chain.",
            link: "https://github.com/freeverseio/laos-examples",
            icon: icon3,
            icon_right: false
        },
    ],
    link_arrows: [
        {
            title: "Technical Whitepaper",
            link: "https://github.com/freeverseio/laos-whitepaper/blob/main/laos.pdf" 
        },
        {
            title: "Block Explorer",
            link: "https://laos.statescan.io/"
        },
        {
            title: "Documentation",
            link: "https://docs.laosnetwork.io"
        },
        {
            title: "Tokenomics",
            link: "https://docs.laosnetwork.io/tokenomics/laos-utility-token/"
        },
        {
            title: "Get Started Guide",
            link: "https://github.com/freeverseio/laos-examples"
        },
        {
            title: "Grant Program",
            link: "/grant-program"
        },
    ],
    faq: [
        {
            title:"How will LAOS Mint NFTs on Bitcoin?",
            text: "LAOS Network uses ‘Bridgeless Minting’ to mint assets on other chains. We are currently extending this functionality to implement a new BRC-721 protocol on Bitcoin. Read the paper to find out more at https://eprint.iacr.org/2025/641"
        },
        {
            title:"What are the benefits of minting BRC721 NFTs on Bitcoin with LAOS?",
            text: "Various attempts have been made to implement Non-Fungible Tokens on Bitcoin (Ordinals, Inscriptions, Runes). LAOS's BRC-721 will scale the throughput to support mainstream applications, such as Real World Assets and Gaming, on Bitcoin."
        },
        {
            title:"Do I need LAOS tokens to mint BRC721 NFTs on Bitcoin?",
            text: "Yes, you will need LAOS tokens to mint assets. You can purchase tokens on exchanges."
        },
        {
            title:"How can I start building?",
            text: "LAOS Bridgeless Minting is available NOW for EVM chains. Bitcoin will come early 2026."
        }
    ]
}

const TIMELINE = [
  {
    date: "Nov 2025",
    title: "BRC-721 Spec Finalisation",
    text: "Striped down version of previous work, removing dependencies on Ordinals, Inscriptions, and Runes",
    status: "in-progress",
    link: "https://eprint.iacr.org/2025/641"
  },
  {
    date: "Nov 2025",
    title: "Transaction Type 1 Available",
    text: "Creation of BRC721 collections on Bitcoin",
    status: "in-progress"
  },
  {
    date: "Dec 2025",
    title: "Transaction Type 2 Available",
    text: "Ownership registration of specific NFTs on BRC721 collections",
    status: "planned"
  },
  {
    date: "Jan 2026",
    title: "Public Indexer",
    text: "Open availability of a public indexer of BRC721 collections and their assets",
    status: "planned"
  },
  {
    date: "Feb 2026",
    title: "Transaction Type 3 Available",
    text: "Trading of NFTs in BRC721 collections",
    status: "planned"
  },
  {
    date: "Mar 2026",
    title: "Transaction Type 4 Available",
    text: "Rebasing of BRC721 collections",
    status: "planned"
  },
  {
    date: "Apr 2026",
    title: "G.A. Documentation",
    text: "Launch and builder partnerships",
    status: "planned"
  }
];

class Bitcoin extends Component {
    render() {
        return (
        <>
        <section>
            <div className="bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-fvorange from-0% via-fvpurple to-fvmidpurple to-50% py-20">
                <div className="w-3/4 sm:w-1/3 mx-auto pt-10 pb-4 flex flex-col">
                    <h1 className="text-center text-fvyellow font-bold text-2xl sm:text-4xl mb-8">{CONTENT.main_title}</h1>
                    <h5 className="text-center sm:text-lg mb-8">{CONTENT.main_text}</h5>
                    <div className="flex flex-col space-y-10 sm:space-y-0 sm:flex-row justify-center sm:space-x-16">
                        <div className="text-center">
                            <a
                            href={CONTENT.button_left.link}
                            className="border border-fvyellow text-fvyellow px-8 py-3 rounded transition duration-300 ease-in-out hover:bg-fvyellow hover:text-fvpurple"
                            >
                            {CONTENT.button_left.text}
                            </a>
                        </div>
                        {/* <div className="text-center">    
                            <a
                            href={CONTENT.button_right.link}
                            className="border border-fvyellow text-fvyellow px-8 py-3 rounded transition duration-300 ease-in-out hover:bg-fvyellow hover:text-fvpurple"
                            >
                            {CONTENT.button_right.text}
                            </a>
                        </div> */}
                    </div>
                </div> 
            </div>  
        </section>

        <LAOSTimeline
        items={TIMELINE}
        headerTitle="LAOS ↔︎ Bitcoin Roadmap"
        headerText="Key milestones and target dates for linking LAOS with Bitcoin using the BRC-721 standard."
        />
        
        <section className='mt-8 mb-8'>
            <h2 className="section-title text-4xl mb-5 text-center">FAQ</h2>
            <hr className="w-[15%] h-[2px] my-4 mx-auto rounded border-0 hr-colored" />
            <div className="container mx-auto flex flex-col">
                {CONTENT.faq.map((item,i) => {
                    return (
                        <DeveloperFAQ key={i} title={item.title} text={item.text} />
                    )
                })}
           </div>
        </section>
        </>
        );
    }
}

export default Bitcoin;